import { flow } from '../../../../lib/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import getTranslatedText from '../../helper/get_translated_text';
import Element from '../elements/elements';
import Tooltip from '../tooltip/tooltip';
import { identity, getURLParameters } from '../../../../lib/utilities';

const Translation = props => {
    const { translationKey, placeholder, tagName } = props;
    const content = getTranslatedText(translationKey, placeholder);
    const formattedContent = flow( props.formatter, toDangerousReactHtml )(content);
    //Dynamically remove properties `removed` -- add ignore in eslint
    const additionalAttributes = Object.keys(Translation.propTypes).reduce((o, key) => {
        const { [key]: removed, ...remainder } = o;
        return remainder;
    }, props);

    const getParams = getURLParameters(location.search);

    if (getParams.show_translation_keys === '1') {
        return (
            <Tooltip
                content={translationKey}
                additionalClassNames={[ 'tooltip--no-style' ]}
            >
                <Element
                    tagName={tagName}
                    dangerouslySetInnerHTML={formattedContent}
                    { ...additionalAttributes }
                />
            </Tooltip>
        );
    }

    return (
        <Element
            tagName={tagName}
            dangerouslySetInnerHTML={formattedContent}
            { ...additionalAttributes }
        />
    );
};

Translation.propTypes = {
    translationKey: PropTypes.string.isRequired,
    placeholder: PropTypes.object,
    tagName: PropTypes.string,
    debug: PropTypes.bool,
    formatter: PropTypes.func,
};

Translation.defaultProps = {
    tagName: 'span',
    placeholder: {},
    debug: false,
    formatter: identity,
};

export { Translation };
export default Translation;
